import fetcher, { HTTPMethods } from "../hooks/fetcher";

export const shopImagesUrl = (influencerId) =>
  `/api/influencer/${influencerId}/images`;

const definedOnly = (fields) =>
  Object.fromEntries(
    Object.entries(fields).filter(([, value]) => value !== undefined),
  );

const REQUESTS = Object.freeze({
  setHeadshot: ({ image, crop }) => ({
    method: HTTPMethods.PUT,
    path: "/headshot",
    body: { image, crop },
  }),
  removeHeadshot: () => ({ method: HTTPMethods.DELETE, path: "/headshot" }),
  setBanner: ({ image }) => ({
    method: HTTPMethods.PUT,
    path: "/banner",
    body: { image },
  }),
  removeBanner: () => ({ method: HTTPMethods.DELETE, path: "/banner" }),
  addCharacter: ({ image, crop, label, influencerCharacterId }) => ({
    method: HTTPMethods.POST,
    path: "/characters",
    body: definedOnly({ image, crop, label, influencerCharacterId }),
  }),
  updateCharacter: ({ imageId, label, influencerCharacterId }) => ({
    method: HTTPMethods.PATCH,
    path: `/characters/${imageId}`,
    body: definedOnly({ label, influencerCharacterId }),
  }),
  reorderCharacters: ({ imageIds }) => ({
    method: HTTPMethods.PUT,
    path: "/characters/order",
    body: { imageIds },
  }),
  removeCharacter: ({ imageId }) => ({
    method: HTTPMethods.DELETE,
    path: `/characters/${imageId}`,
  }),
  recrop: ({ imageId, crop }) => ({
    method: HTTPMethods.PUT,
    path: `/${imageId}/crop`,
    body: { crop },
  }),
});

export const shopImageRequest = (action, args) => {
  const build = REQUESTS[action];

  if (!build) throw new Error(`unknown shop image action: ${action}`);

  return build(args);
};

export const sendShopImageRequest = ({ influencerId, action, args }) => {
  const { method, path, body } = shopImageRequest(action, args);

  return fetcher(`${shopImagesUrl(influencerId)}${path}`, {
    method,
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
};
